import { Thumbnail } from '@wix/design-system';
import { assets } from 'config/assets';
import React, { FC } from 'react';
import { useAppStore } from 'stores/appStore';
import styles from '../SelectImageStep.scss';
import { useMockupStore } from 'stores/mockupStore';

type Props = {
  onItemClick: () => void;
};

export const SelectImageStepOptions: FC<Props> = ({ onItemClick }) => {
  const mediaUrl = useAppStore((state) => state.mediaUrl);
  const setMediaUrl = useAppStore((state) => state.setMediaUrl);

  const isLoading = useMockupStore((state) => state.isLoading);

  return (
    <div className={styles.selectImageStepOptions}>
      {assets.map((asset) => {
        const isSelected = mediaUrl === asset.imageUrl;
        return (
          <Thumbnail
            disabled={isLoading && !isSelected}
            selected={isSelected}
            key={asset.imageUrl}
            onClick={() => {
              onItemClick();
              setMediaUrl(asset.imageUrl);
            }}
          >
            <div className={styles.selectImageStepOptionsItem}>
              <img src={asset.imageUrl} alt={asset.imageUrl} />
            </div>
          </Thumbnail>
        );
      })}
    </div>
  );
};
